export default __webpack_public_path__ + "static/media/MONGODB.b92689dd.jpg";